import { render } from "./MSubjectsInput.vue?vue&type=template&id=26fa3cd4"
import script from "./MSubjectsInput.vue?vue&type=script&lang=ts"
export * from "./MSubjectsInput.vue?vue&type=script&lang=ts"
script.render = render

export default script